import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  ke,
  r as r2
} from "./chunk.WKUNRGJV.js";
import {
  n
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-bypass-block/jb-bypass-block.scss?inline
var jb_bypass_block_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

*:focus-visible {
  outline-color: rgb(var(--theme-color-signal-blue, 0 37 255));
  outline-offset: 6px;
  outline-style: var(--focus-outline-style, auto);
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
.bypass-block > button, .bypass-block > a {
  font-family: var(--theme-font-bold-family, VerlagSSm, Tahoma, sans-serif);
  font-weight: var(--theme-font-bold-weight, 700);
}

.bypass-block > button, .bypass-block > a {
  font-size: var(--theme-typo-p-small-highlight-desktop-fontsize, 1rem);
  line-height: var(--theme-typo-p-small-highlight-desktop-lineheight, 1.625rem);
}

/* special measurements */
:host {
  color: var(--host-color, #141e55);
}

:host {
  --_display-bypass-block: block;
  --_element-block-size: 40px;
}

.bypass-block {
  background: rgb(var(--color-main-white));
  display: var(--_display-bypass-block);
  inset-block-start: var(--spacing-sm);
  inset-inline-start: var(--spacing-sm);
  position: fixed;
  z-index: 552;
}
@media (min-width: 960px) {
  .bypass-block {
    inset-block-start: var(--spacing-l);
    inset-inline-start: var(--spacing-xl);
  }
}
.bypass-block > button, .bypass-block > a {
  appearance: none;
  block-size: 0;
  border: none;
  box-sizing: border-box;
  display: var(--_display-bypass-block);
  inline-size: max-content;
  line-height: var(--_element-block-size);
  min-inline-size: 272px;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  text-align: center;
  text-decoration: none;
}
.bypass-block:focus-within > *:focus {
  background: rgb(var(--theme-color-signal-blue, 0 37 255));
  block-size: var(--_element-block-size);
  color: white;
  cursor: pointer;
  opacity: 1;
  pointer-events: all;
}`;

// src/components/jb-bypass-block/jb-bypass-block.ts
var JbBypassBlock = class extends r2 {
  _handleKeyDown(evt) {
    if (evt.code === "Space") {
      evt.preventDefault();
      evt.target.click();
    }
  }
  _handleMouseEventBypassBlock(evt) {
    const itemName = evt.target.dataset.name;
    this.dispatchEvent(
      new CustomEvent("jb-bypass-block:navigate", { detail: { name: itemName }, bubbles: true, composed: true })
    );
  }
  render() {
    return ke`<div class="bypass-block">
      ${this.items.map(
      (item) => ke`${item.href ? ke`<a
                aria-label="${item.label}"
                data-name="${item.name}"
                href="${item.href}"
                role="button"
                @click=${this._handleMouseEventBypassBlock}
                @keydown=${this._handleKeyDown}
              >
                ${item.label}
              </a>` : ke`<button
                aria-label="${item.label}"
                data-name="${item.name}"
                @click=${this._handleMouseEventBypassBlock}
              >
                ${item.label}
              </button>`}`
    )}
    </div>`;
  }
};
JbBypassBlock.styles = r(jb_bypass_block_default);
__decorateClass([
  n({ type: Array })
], JbBypassBlock.prototype, "items", 2);
JbBypassBlock = __decorateClass([
  customElement("jb-bypass-block")
], JbBypassBlock);

export {
  JbBypassBlock
};
